import React, { Component, ErrorInfo, ReactNode } from 'react';
import { Button, Result } from 'antd';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
}

class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Error capturado por ErrorBoundary:', error, errorInfo);
    
    // Si es un error de hot reloading, intentar recargar automáticamente
    if (error.message.includes('fsm.js') || error.message.includes('Cannot read properties of undefined')) {
      console.log('Error de hot reloading detectado, recargando automáticamente...');
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    }
  }

  handleReload = () => {
    // Limpiar localStorage corrupto
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('user');
    
    // Recargar la página
    window.location.reload();
  };

  handleClearCache = () => {
    // Limpiar todo el localStorage
    localStorage.clear();
    
    // Recargar la página
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ 
          display: 'flex', 
          justifyContent: 'center', 
          alignItems: 'center', 
          height: '100vh',
          padding: '20px'
        }}>
          <Result
            status="error"
            title="Error en la aplicación"
            subTitle="La aplicación encontró un error inesperado. Esto puede deberse a datos corruptos en el caché."
            extra={[
              <Button type="primary" key="reload" onClick={this.handleReload}>
                Recargar aplicación
              </Button>,
              <Button key="clear" onClick={this.handleClearCache}>
                Limpiar caché y recargar
              </Button>,
            ]}
          />
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
